import './Footer.css'

const Footer = () => {
    return (
        <>
        <footer>
            <p className="text-center">Haneefah Witherspoon @ 2024</p>
        </footer>
            </>
    )
}

export default Footer;